import { render, staticRenderFns } from "./saomapay.vue?vue&type=template&id=5b0f72f7&scoped=true&"
import script from "./saomapay.vue?vue&type=script&lang=js&"
export * from "./saomapay.vue?vue&type=script&lang=js&"
import style0 from "./saomapay.vue?vue&type=style&index=0&id=5b0f72f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f72f7",
  null
  
)

export default component.exports